// @flow

import React from 'react';
import _ from 'lodash/fp';
import SelectFormInput from '../SelectFormInput/SelectFormInput';

export type Props = {
  input: any,
  label: string,
  specialProducts: Object,
  productTypes: any[],
};

const SpecialProductsInput = ({
  input,
  label,
  specialProducts,
  productTypes,
}: Props) => (
  <div>
    <label>
      {label}
    </label>
    <div>
      {!_.isEmpty(productTypes)
        ? _.map(productType => {
          const options = specialProducts[productType.id];
          const value = _.filter(({id}) => !!_.find({id}, options), input.value);
          return (
            <SelectFormInput
              key={productType.id}
              input={{
                value,
                onBlur: _.noop,
                onChange: val => {
                  const selected = _.map(_.pick(['id']), val);
                  const removed = _.differenceBy('id', value, selected);
                  const withoutRemoved = _.reject(({id}) =>
                    _.some({id}, removed), input.value);
                  input.onChange(_.unionBy('id', selected, withoutRemoved));
                },
              }}
              meta={{}}
              label={productType.name}
              multi={true}
              valueKey="id"
              labelKey="name"
              options={options} />
          );
        }, productTypes)
        : (
          <span>Inga specialprodukter tillgängliga</span>
        )
      }
    </div>
  </div>
);

export default SpecialProductsInput;



// WEBPACK FOOTER //
// ./src/components/SpecialProductsInput/SpecialProductsInput.js